module.exports = __webpack_public_path__ + "img/br44.5528cf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br44.jpg
// module id = Jktc
// module chunks = 0